<div class="db-booster-page-score">
  <db-loading-screen *ngIf="loading"></db-loading-screen>
  <div class="db-booster-page-score__title">
    <h3>{{trialBoosterWithHosted ? ('tooltip_text_overview.score.widget.header' | dbText) : ((userSubscription?.paidClient || !!website?.domain_hash) ? ('text_optimizedScoreWebsite' | dbText) : !boosterPluginIsActive ? ('tooltip_text_overview.score.widget.header' | dbText) : ('text_optimizedScoreWebsite' | dbText))}}
      <div class="db-booster-page-score__improve"
           *ngIf="showImproveBadge && improvedPercent && !analyzing && !analyzingBefore">
        <img class="mr4" src="assets/images/icons/light.svg">
        <p>Improved <span>{{improvedPercent}}%</span></p>
      </div>
    </h3>
  </div>


  <div class="db-booster-page-score__scores">
    <div class="db-booster-page-score__card db-page-status__score-card">
      <i class="db-icon db-icon-ds-mobile"></i>
      <ds-score [score]="currentMobileScore" [error]="!currentMobileScore || currentMobileScore === 101"
                [loading]="analyzing" size="l" [withShadow]="false"></ds-score>
      <p class="title">{{'text_mobileScore' | dbText}}</p>
      <p>{{'text_moveTo10web.loadTime' | dbText}}:
        {{analyzing || !currentMobileTTI || currentMobileTTI === 42 ? '&mdash; &mdash;' : currentMobileTTI + 's'}}</p>
    </div>

    <div class="db-booster-page-score__card db-page-status__score-card">
      <i class="db-icon db-icon-ds-desktop"></i>
      <ds-score [score]="currentDesktopScore" [error]="!currentDesktopScore || currentDesktopScore === 101"
                [loading]="analyzing" size="l" [withShadow]="false"></ds-score>
      <p class="title">{{'text_desktopScore' | dbText}}</p>
        <p>{{'text_moveTo10web.loadTime' | dbText}}:
            {{analyzing || !currentDesktopTTI || currentDesktopTTI === 42 ? '&mdash; &mdash;' : currentDesktopTTI + 's'}}</p>
    </div>

    <div class="db-booster-page-score__card db-booster-page-score__analyze-card"
         [ngClass]="{'disabled-with-overlay': demoUser}">
      <p>{{'text_checkScoreWith' | dbText}}</p>
      <a target="_blank" rel="noopener"
         href="https://developers.google.com/speed/pagespeed/insights/?url={{websiteUrl}}">{{'text_googlePageSpeedInsights' | dbText}}</a>
      <div class="buttons-wrap">
        <button *ngIf="!analyzing" class="ds-btn mt30 mb20" (click)="recheckScore()">
          <span>{{boosterPluginIsActive ? ('text_reanalyzeButton' | dbText) : 'Optimize'}}</span>
        </button>
      </div>
      <ds-progress-bar *ngIf="analyzing" class="display-block mb10 mt20"
                       color="green" [progressPercent]="analyzingProgress" title="Analyzing..."
                       label="complete"></ds-progress-bar>
      <ng-container *ngIf="currentLastOptimizedDate">
        <hr class="mb8">
        <p><b>{{'text_lastAnalyzed' | dbText}}:</b></p>
        <p [innerHTML]="currentLastOptimizedDate | date : 'MMM d, y, h:mm a' : timezone"></p>
      </ng-container>
    </div>

    <div class="db-booster-page-score__card db-booster-page-score__scale-card">
      <p>{{'text_scaleLabel' | dbText}}: <span></span> 90-100 ({{'text_fastLabel' | dbText}})
        <span class="yellow"></span> 50-89 ({{'text_averageLabel' | dbText}})
        <span class="red"></span> 0-49 ({{'text_slowLabel' | dbText}})</p>
    </div>
  </div>

  <div class="db-booster-page-score__before-after-wrap mt25" *ngIf="boosterPluginIsActive && !website?.domain_hash">
    <p class="db-booster-page-score__before-title">{{'text_beforeOptimization' | dbText}}</p>
    <div class="db-booster-page-score__before-after">
      <div>
        <ds-score [score]="originalMobileScore" [loading]="analyzingBefore" [error]="!originalMobileScore" size="m" [withShadow]="false"></ds-score>
        <div>
          <p class="title">{{'text_mobileScore' | dbText}}</p>
          <p>{{'text_moveTo10web.loadTime' | dbText}}: {{!originalMobileTTI ? '&mdash; &mdash;' : originalMobileTTI + 's'}}</p>
        </div>

      </div>
      <div>
        <ds-score [score]="originalDesktopScore" [loading]="analyzingBefore"  [error]="!originalDesktopScore" size="m"
                  [withShadow]="false"></ds-score>
        <div>
          <p class="title">{{'text_desktopScore' | dbText}}</p>
          <p>{{'text_moveTo10web.loadTime' | dbText}}: {{!originalDesktopTTI ? '&mdash; &mdash;' : originalDesktopTTI + 's'}}</p>
        </div>

      </div>
      <div>
        <div *ngIf="originalLastOptimizedDate">
          <p class="title">Analyzed on:</p>
          <p class="desc" [innerHTML]="originalLastOptimizedDate | date : 'MMM d, y, h:mm a' : timezone"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="ds-notification ds-notification-error mt20"
       *ngIf="optimizerPlugin && !optimizerPlugin.active && websiteHosted">
    <div>
      <i class="db-icon db-icon-ds-close-bg"></i>
      <span>
      <b>{{ companyName }} Booster plugin is not installed.</b> The {{ companyName }} Booster plugin is mandatory for optimizing your website PageSpeed score.
        <a [ngClass]="{'disabled': loading}" (click)="enableBoosterPlugin()">Optimize my website</a>
      </span>
    </div>
  </div>
</div>
